"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_pdf_1 = require("react-pdf");
var ui_1 = require("@aperza/ui");
var AcPdfNavigationToolbar_1 = require("./AcPdfNavigationToolbar");
var AcPdfEditor_1 = require("../pdfEditor/AcPdfEditor");
var AcDocumentViewer_module_scss_1 = __importDefault(require("./AcDocumentViewer.module.scss"));
var RotationButtons_1 = require("./RotationButtons");
var AcToast_1 = require("../notification/AcToast");
var DownloadPdf_1 = require("./DownloadPdf");
var AcPdfPagination_1 = require("./AcPdfPagination");
var NotPersonInCharge_1 = require("../pdfEditor/modals/NotPersonInCharge");
exports.CanvasContext = react_1.default.createContext(null);
exports.AcPdf = function (_a) {
    var pdfSource = _a.pdfSource, editing = _a.editing, enablePdfAction = _a.enablePdfAction, faxId = _a.faxId, faxDocument = _a.faxDocument, faxDocumentType = _a.faxDocumentType, showRotation = _a.showRotation, options = _a.options, handleShowEditor = _a.handleShowEditor, handleCancel = _a.handleCancel, fabricDataMapJSON = _a.fabricDataMapJSON, onCreateDraft = _a.onCreateDraft, validateInCharge = _a.validateInCharge, updateInCharge = _a.updateInCharge;
    var _b;
    var history = react_router_dom_1.useHistory();
    var _c = react_1.useState(0), pageNumber = _c[0], setPageNumber = _c[1];
    var _d = react_1.useState(), pdfDoc = _d[0], setPdfDoc = _d[1];
    var _e = react_1.useState(), pdfPage = _e[0], setPdfPage = _e[1];
    var _f = react_1.useState(editing || false), edit = _f[0], setEdit = _f[1];
    var canvasMethodsRef = react_1.useRef();
    var pdfViewDivRef = react_1.useRef(null);
    var pageNumberRef = react_1.useRef(0);
    var _g = react_1.useState({
        originalWidth: 0,
        originalHeight: 0,
        rotatedWidth: 0,
        rotatedHeight: 0,
        pageNumber: 0,
        rotate: 0,
    }), editorDimension = _g[0], setEditorDimension = _g[1];
    var _h = react_1.useState([]), initialRotationArray = _h[0], setInitialRotationArray = _h[1]; // just used to check if anything changed.  If nothing changed don't save
    var _j = react_1.useState([]), rotationArray = _j[0], setRotationArray = _j[1];
    var _k = react_1.useState(false), showNotPersonInCharge = _k[0], setShowNotPersonInCharge = _k[1];
    /**
     * To update the pageNumber state and pageNumberRef
     */
    var updatePageNumber = function (_pageNumber) {
        setPageNumber(_pageNumber);
        pageNumberRef.current = _pageNumber;
        canvasMethodsRef.current.resetNewStampOffsetCounter();
    };
    /**
     * Since the rotation state isn't watched in state anymore, we have to trigger the rerender manually
     */
    var updateRotationArray = function (_rotationArray) {
        canvasMethodsRef.current.setRotationArray(_rotationArray);
        setRotationArray(_rotationArray);
    };
    var getPdfViewWidth = function () {
        var _a;
        if (pdfViewDivRef === null || pdfViewDivRef === void 0 ? void 0 : pdfViewDivRef.current) {
            return (_a = pdfViewDivRef === null || pdfViewDivRef === void 0 ? void 0 : pdfViewDivRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        }
        return pdfPage ? pdfPage.getViewport({ scale: 1 }).width : 500;
    };
    var getPdfViewHeight = function () {
        var _a;
        if (pdfViewDivRef === null || pdfViewDivRef === void 0 ? void 0 : pdfViewDivRef.current) {
            return (_a = pdfViewDivRef === null || pdfViewDivRef === void 0 ? void 0 : pdfViewDivRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        }
        return pdfPage ? pdfPage.getViewport({ scale: 1 }).height : 800;
    };
    /**
     * Use ref so that the function can be linked to element listener
     */
    var updateEditorDimension = function () {
        var editorPageNumber = pageNumberRef.current;
        var rotation = canvasMethodsRef.current.getRotationArray()[editorPageNumber - 1];
        if (rotation % 180 === 0) {
            var originalWidth = getPdfViewWidth();
            var originalHeight = getPdfViewHeight();
            setEditorDimension({
                originalWidth: originalWidth,
                originalHeight: originalHeight,
                rotatedWidth: originalWidth,
                rotatedHeight: originalHeight,
                pageNumber: editorPageNumber,
                rotate: rotation,
            });
        }
        else {
            var originalWidth = getPdfViewHeight();
            var originalHeight = getPdfViewWidth();
            setEditorDimension({
                originalWidth: originalWidth,
                originalHeight: originalHeight,
                rotatedWidth: originalHeight,
                rotatedHeight: originalWidth,
                pageNumber: editorPageNumber,
                rotate: rotation,
            });
        }
    };
    var onDocumentLoadSuccess = function (doc) {
        var _a;
        setPdfDoc(doc);
        if (!(((_a = canvasMethodsRef.current.getExistingPages()) === null || _a === void 0 ? void 0 : _a.length) > 0)) {
            var _existingPages = [];
            for (var i = 0; i < doc.numPages; i++) {
                _existingPages.push(i + 1);
            }
            canvasMethodsRef.current.setExistingPages(_existingPages);
        }
        updatePageNumber(canvasMethodsRef.current.getExistingPages()[0]);
    };
    var onPageLoadSuccess = function (page) {
        if (canvasMethodsRef.current.getRotationArray()[pageNumber - 1] === undefined) {
            // since the page loads every time we view it, we don't want to overwrite our rotation array with the page's initial rotation
            var temp = __spreadArrays(canvasMethodsRef.current.getRotationArray());
            temp[pageNumber - 1] = page.rotate;
            updateRotationArray(temp);
            setInitialRotationArray(function (prev) {
                prev[pageNumber - 1] = page.rotate;
                return prev;
            });
        }
        setPdfPage(page);
    };
    /**
     * Called when a pdf page is rendered for the first time (change page number) or rotated
     */
    var onPageRenderSuccess = function (page) {
        if (page.pageIndex === pageNumber - 1) {
            // for some reason it renders the previous page first on page change
            updateEditorDimension();
        }
    };
    var deletePage = function (deletedPageNumber) {
        if (canvasMethodsRef.current.getExistingPages().length === 1) {
            AcToast_1.notifyMessage('これ以上はページを削除できません。', 'ERROR');
            console.error('Cannot delete last page');
            return;
        }
        var newExistingPages = __spreadArrays(canvasMethodsRef.current.getExistingPages());
        var existingPagesIndex = canvasMethodsRef
            .current.getExistingPages()
            .indexOf(deletedPageNumber);
        newExistingPages.splice(existingPagesIndex, 1);
        canvasMethodsRef.current.setExistingPages(newExistingPages);
        if (existingPagesIndex < newExistingPages.length) {
            updatePageNumber(newExistingPages[existingPagesIndex]);
        }
        else {
            //if was on last page
            updatePageNumber(newExistingPages[existingPagesIndex - 1]);
        }
    };
    var onClickAction = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var existingPagesIndex;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pdfDoc) return [3 /*break*/, 2];
                    existingPagesIndex = canvasMethodsRef.current.getExistingPages().indexOf(pageNumber);
                    if (action === 'PREV_PAGE') {
                        if (existingPagesIndex > 0) {
                            updatePageNumber(canvasMethodsRef.current.getExistingPages()[existingPagesIndex - 1]);
                        }
                    }
                    if (action === 'NEXT_PAGE') {
                        if (existingPagesIndex < canvasMethodsRef.current.getExistingPages().length - 1) {
                            updatePageNumber(canvasMethodsRef.current.getExistingPages()[existingPagesIndex + 1]);
                        }
                    }
                    if (!(action === 'EDIT')) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateInCharge(faxDocument)];
                case 1:
                    if (!(_a.sent()))
                        return [2 /*return*/];
                    if (faxDocument.inCharge === 'NONE') {
                        updateInCharge(faxDocument, 'MINE');
                    }
                    setEdit(!edit);
                    if (handleShowEditor) {
                        handleShowEditor(!edit);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var sendEditedFax = function () { return __awaiter(void 0, void 0, void 0, function () {
        var editedPdfDoc, pdfBlob, pdfBlobURL_1, newFabricDataMap, newFabricDataMapJSON, numPages, callback, userInCharge;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pdfDoc) return [3 /*break*/, 4];
                    return [4 /*yield*/, DownloadPdf_1.createPdf(pdfDoc, canvasMethodsRef)];
                case 1:
                    editedPdfDoc = _a.sent();
                    pdfBlob = editedPdfDoc.output('blob');
                    pdfBlobURL_1 = URL.createObjectURL(pdfBlob);
                    newFabricDataMap = canvasMethodsRef.current.getFabricDataMap();
                    newFabricDataMapJSON = JSON.stringify(newFabricDataMap);
                    numPages = canvasMethodsRef.current.getExistingPages().length;
                    if (!onCreateDraft) return [3 /*break*/, 3];
                    callback = function (draftFaxDocument) {
                        if (draftFaxDocument) {
                            history.push({
                                pathname: "/fax/sendDraft/" + draftFaxDocument.faxId,
                                state: { draftDocument: draftFaxDocument, pdfSource: pdfBlobURL_1 },
                            });
                        }
                    };
                    return [4 /*yield*/, onCreateDraft(numPages, newFabricDataMapJSON, faxDocument === null || faxDocument === void 0 ? void 0 : faxDocument.note1, callback)];
                case 2:
                    userInCharge = _a.sent();
                    if (userInCharge === false) {
                        setShowNotPersonInCharge(true);
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
                case 3:
                    console.error('Unable to create draft');
                    _a.label = 4;
                case 4: return [2 /*return*/, false];
            }
        });
    }); };
    var pageOnclickRotation = function (ref) {
        if (ref && showRotation) {
            ref.onclick = function () {
                var temp = __spreadArrays(canvasMethodsRef.current.getRotationArray());
                temp[pageNumber - 1] = (temp[pageNumber - 1] + 90) % 360;
                updateRotationArray(temp);
            };
            ref.style.cursor = RotationButtons_1.CURSOR_SVG;
        }
    };
    var resize = function () {
        updateEditorDimension();
    };
    ui_1.useWindowResize(resize);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.CanvasContext.Provider, { value: canvasMethodsRef },
            react_1.default.createElement(AcPdfNavigationToolbar_1.AcPdfNavigationToolbar, { pdfSource: pdfSource, faxDocument: faxDocument, faxDocumentType: faxDocumentType, onClickAction: onClickAction, page: pageNumber, pdfDoc: pdfDoc, setRotationArray: updateRotationArray, initialRotationArray: initialRotationArray, handleCancel: handleCancel, enablePdfAction: enablePdfAction, showEditor: editing || edit, deletePage: deletePage, onCreateDraft: onCreateDraft }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "text-center" },
                    react_1.default.createElement("div", { ref: pdfViewDivRef, className: "position-relative d-inline-block" },
                        react_1.default.createElement(react_pdf_1.Document, { file: pdfSource, onLoadSuccess: onDocumentLoadSuccess, options: options }, pageNumber && ( // render page after the doc has been loaded.
                        react_1.default.createElement(react_pdf_1.Page, { className: AcDocumentViewer_module_scss_1.default.pdfViewer, pageNumber: pageNumber, renderAnnotationLayer: false, renderTextLayer: false, onLoadSuccess: onPageLoadSuccess, 
                            // @ts-ignore
                            onRenderSuccess: onPageRenderSuccess, inputRef: pageOnclickRotation, rotate: rotationArray[pageNumber - 1] }))),
                        react_1.default.createElement(AcPdfEditor_1.AcPdfEditor, { show: editing || edit, faxDocument: faxDocument, pageNumber: editorDimension.pageNumber, originalWidth: editorDimension.originalWidth, originalHeight: editorDimension.originalHeight, rotatedWidth: editorDimension.rotatedWidth, rotatedHeight: editorDimension.rotatedHeight, rotate: editorDimension.rotate, sendEditedFax: sendEditedFax, onCreateDraft: onCreateDraft, handleCancel: handleCancel, fabricDataMapJSON: fabricDataMapJSON, updateRotationArray: updateRotationArray }),
                        react_1.default.createElement(AcPdfPagination_1.AcPdfPagination, { onClickAction: onClickAction, pageNumber: pageNumber, existingPages: (_b = canvasMethodsRef.current) === null || _b === void 0 ? void 0 : _b.getExistingPages() }))))),
        showNotPersonInCharge && (react_1.default.createElement(NotPersonInCharge_1.NotPersonInCharge, { closeNotPersonInChargeModal: function () { return setShowNotPersonInCharge(false); } }))));
};
exports.AcPdf.displayName = 'AcPdf';
//# sourceMappingURL=AcPdf.js.map